import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexAttendanceLogRequest = ({
  dispatch,
  params = {},
  format = '',
  responseType = 'json',
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('get', `/admin/attendance_logs${format}`, {
    dispatch,
    params,
    responseType,
    failureCallback,
    successCallback,
    callback
  });
};

export const resendAttendanceLogRequest = ({
  dispatch,
  params = {},
  format = '',
  responseType = 'json',
  failureCallback,
  successCallback,
  callback
}) => {
  ApiService.request('post', `/admin/attendance_logs/resend${format}`, {
    dispatch,
    params,
    responseType,
    failureCallback,
    successCallback,
    callback
  });
};

export const debounceIndexAttendanceLogRequest = AwesomeDebouncePromise(indexAttendanceLogRequest, 300);